// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"0a4540a2","298":"ed2c437b","408":"be592d06","453":"9e8f7c5c","750":"abe524c1","880":"bd22ef49"}[chunkId] + ".chunk.js";
};